<script>
import AppLogo from "@/components/AppLogo.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import {useI18n} from 'vue-i18n';
import {log} from "@/utils/clientLogger.js";

export default {
  name: "LoginPage",
  components: {
    AppLogo,
    LanguageSwitcher
  },
  data() {
    return {
      username: "",
      password: ""
    };
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  methods: {
    login() {
      const {username, password} = this;
      this.$store.dispatch('login', {username, password})
          .then(() => this.$router.push('/'))
          .catch(err => log.error('View:LoginPage:login', {'error': err}));
    }
  }
};
</script>

<template>
  <div class="container">
    <div id="login_row" class="row h-100 align-items-center justify-content-center">
      <form @submit.prevent="login" class="col-md-8 g-3 needs-validation novalidate">
        <div class="col-md-6 mx-auto text-center mb-4">
          <AppLogo width="120"/>
        </div>

        <div class="col-md-5 mx-auto">
          <label for="validationCustomUsername" class="form-label">{{ t('auth.loginLabel') }}</label>
          <div class="input-group has-validation">
            <span class="input-group-text" id="inputGroupPrepend">@</span>
            <input
                type="text"
                v-model="username"
                class="form-control"
                id="validationCustomUsername"
                aria-describedby="inputGroupPrepend"
                required
            >
            <div class="invalid-feedback">
              {{ t('auth.loginRequired') }}
            </div>
          </div>
        </div>

        <div class="col-md-5 mb-3 mx-auto mt-3">
          <label class="form-label" for="password">
            {{ t('auth.passwordLabel') }}
          </label>
          <input
              id="password"
              class="form-control"
              type="password"
              v-model="password"
              required
              :placeholder="t('auth.passwordPlaceholder')"
          >
        </div>

        <div class="col-md-5 text-center mx-auto my-3">
          <button type="submit" class="btn btn-success w-50 mx-auto">{{ t('auth.loginButton') }}</button>
        </div>
        <div class="col-md-5 text-center mx-auto">
          <LanguageSwitcher/>
        </div>
      </form>

      <small class="col-md-8 mx-auto text-center">{{ t('auth.loginNote') }}</small>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  height: 100vh;
}
</style>